// extracted by css-extract-rspack-plugin
export default {"cls1":"ZeroState-cls1_k3J","cls2":"ZeroState-cls2_BlC ZeroState-cls1_k3J"};